"use client"

import type { ReactNode } from "react"
import Link from "next/link"
import { useSession } from "next-auth/react"

export default function SiteLogoLink({
  initiallyAuthenticated,
  children,
}: {
  initiallyAuthenticated: boolean
  children: ReactNode
}) {
  const { data: session, status } = useSession()
  const authenticated =
    status === "loading" ? initiallyAuthenticated : !!session?.user

  return (
    <Link href={authenticated ? "/home" : "/"} className="h-full flex-none">
      {children}
    </Link>
  )
}
